import React, { useState } from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
function RevealBlock({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const ref = useScrollReveal<HTMLDivElement>();
  return <div ref={ref} className={`opacity-0 translate-y-10 transition-all duration-700 ease-out ${className}`} data-id="element-39">
      {children}
    </div>;
}
interface FaqItemData {
  question: string;
  answer: string;
}
const faqData: FaqItemData[] = [{
  question: '¿Tengo que dejar los carbohidratos o hacer ayuno intermitente?',
  answer: 'Para nada. Este protocolo no elimina ningún grupo alimenticio. Te enseña el ORDEN correcto para comerlos sin disparar la insulina. Puedes comer pan, arroz y fruta. Solo aprenderás cuándo y cómo.'
}, {
  question: '¿Funciona si ya pasé la menopausia?',
  answer: 'Especialmente si ya la pasaste. Cuando el estrógeno está en su nivel más bajo, el cuerpo es más sensible al cortisol que nunca. Las estrategias de este protocolo están diseñadas exactamente para ese estado hormonal.'
}, {
  question: '¿Cuánto tiempo al día necesito para esto?',
  answer: 'El protocolo completo requiere 10 minutos activos al día. El resto son cambios de comportamiento (como el orden en que comes) que no requieren tiempo extra. Solo un poco de consciencia.'
}, {
  question: '¿Necesito comprar suplementos caros?',
  answer: 'No. El único suplemento que mencionamos cuesta alrededor de $10 USD y se consigue en cualquier farmacia. Y es completamente opcional, los resultados funcionan sin él también.'
}, {
  question: '¿Por qué el precio es tan bajo si el contenido es tan valioso?',
  answer: 'Porque estamos en fase de validación. Queremos que las primeras 100 mujeres lo prueben, vean resultados reales y nos compartan su testimonio. A cambio, tú obtienes el protocolo completo por el precio de un café. Es un intercambio justo.'
}];
export function FaqSection() {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setActiveIndex(prev => prev === index ? null : index);
  };
  return <section className="bg-gris-fondo py-20 px-5" data-id="element-40">
      <div className="max-w-[760px] mx-auto" data-id="element-41">
        <RevealBlock data-id="element-42">
          <p className="text-[0.8rem] font-bold tracking-[2px] uppercase text-verde-bosque mb-3 flex items-center gap-2 justify-center" data-id="element-43">
            Preguntas Frecuentes
          </p>
        </RevealBlock>

        <RevealBlock data-id="element-44">
          <h2 className="font-display font-bold text-negro-carbon leading-[1.25] mb-6 text-center" style={{
          fontSize: 'clamp(1.6rem, 4vw, 2.4rem)'
        }} data-id="element-45">
            Lo que necesitas saber
            <br data-id="element-46" />
            <span className="text-verde-bosque" data-id="element-47">antes de tomar acción</span>
          </h2>
        </RevealBlock>

        <RevealBlock data-id="element-48">
          <div className="max-w-[700px] mx-auto mt-10 space-y-3" data-id="element-49">
            {faqData.map((item, index) => <FaqItem key={index} question={item.question} answer={item.answer} isActive={activeIndex === index} onToggle={() => toggle(index)} data-id="element-50" />)}
          </div>
        </RevealBlock>
      </div>
    </section>;
}
function FaqItem({
  question,
  answer,
  isActive,
  onToggle
}: {
  question: string;
  answer: string;
  isActive: boolean;
  onToggle: () => void;
}) {
  return <div className={`bg-white rounded-card shadow-[0_2px_8px_rgba(0,0,0,0.05)] overflow-hidden border transition-all duration-300 ${isActive ? 'border-verde-bosque' : 'border-transparent hover:border-verde-bosque'}`} data-id="element-51">
      <button className="w-full bg-transparent border-none py-[22px] px-6 flex justify-between items-center cursor-pointer text-left font-body text-[0.97rem] font-semibold text-negro-carbon transition-colors duration-300 hover:text-verde-bosque" onClick={onToggle} aria-expanded={isActive} data-id="element-52">
        {question}
        <span className={`text-xl text-verde-bosque flex-shrink-0 ml-3 transition-transform duration-300 ${isActive ? 'rotate-45' : ''}`} data-id="element-53">
          +
        </span>
      </button>
      <div className="overflow-hidden transition-all duration-400 ease-in-out" style={{
      maxHeight: isActive ? '300px' : '0',
      padding: isActive ? '0 24px 22px' : '0 24px'
    }} data-id="element-54">
        <p className="text-gray-700 text-[0.93rem] leading-[1.8] border-t border-gris-fondo pt-4" data-id="element-55">
          {answer}
        </p>
      </div>
    </div>;
}